
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStageZacisnijKolejkeGold(targetId,proces_nazwa_id,refreshGantAll) {

// id = procesor id
  
if(proces_nazwa_id==6){

    axios
  .get(IP + "API_0024_gant_procedura_zacisnij_kolejke_oprawa_gold/"+targetId+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })




}else{
    axios
  .get(IP + "API_0016_gant_procedura_zacisnij_kolejke_gold/"+targetId+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })
}

}

//   +"/" + sessionStorage.getItem("token")

